<div class="library">
    <div class="container">
        <div class="row mt-3">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb fqg f18">
                    <li class="mr-3">
                        <a href="/index"><img src="/assets/images/icon-yurt.png" alt="home"></a>
                    </li>
                    <li class="breadcrumb-item"><a href="/library" class="mgl"> ᠨᠣᠮ ᠤᠨ ᠣᠷᠳᠣᠨ</a></li>
                    <li aria-current="page" class="breadcrumb-item active"><span class="mgl">{{bookContent[0].title}}</span></li>
                </ol>
            </nav>
        </div>
        <div class="intro row mt-2 mb-5">
            <div class="col-md-5 mb-3">
                <div class="book-img">
                    <div class="sp-loading">
                        <img src="/assets/images/sp-loading.gif" alt="">
                        <br>
                        <span class="mgl fqg mt-1">ᠵᠢᠷᠤᠭ ᠠᠴᠢᠶᠠᠯᠠᠵᠤ ᠪᠣᠢ ᠁</span>
                    </div>
                    <div class="sp-wrap" id="spWrap">
                        <a href="{{url + di.path}}" *ngFor="let di of bImages;let i = index">
                            <img src="{{url + di.path}}" alt="">
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <h4 class="mgl fgq f24 ml-0 float-left">{{bookContent[0].title}}</h4>
                <div class="book-info float-left scrollbar_s" id="scrollX">
                    <p class="mgl fhw f18 m-0">
                        <span class="fgq f18 mb-2"> ᠵᠣᠬᠢᠶᠠᠭᠴᠢ \ ᠄ </span><span>{{bookContent[0].author}}</span>
                        <br><span class="fgq f18 mb-2"> ᠲᠠᠨᠢᠯᠴᠠᠭᠤᠯᠭ᠎ᠠ᠄</span> {{bContent}}
                        <br><span class="fgq f18 mb-2"> ISBN᠄</span><span>{{bookContent[0].bookNum}}</span>
                        <br><span class="fgq f18 mb-2"> ᠬᠠᠭᠤᠳᠠᠰᠤ ᠶᠢᠨ ᠵᠦᠰᠦᠮ᠄</span><span>{{bookContent[0].bookFormat}} ᠵᠦᠰᠦᠮ</span>
                        <br><span class="fgq f18 mb-2"> ᠨᠢᠭᠤᠷ ᠤᠨ ᠲᠣᠭ᠎ᠠ᠄</span><span>{{bookContent[0].pageNum}} ᠨᠢᠭᠤᠷ</span>
                        <br><span class="fgq f18 mb-2"> ᠬᠡᠪᠯᠡᠭᠰᠡᠨ ᠴᠠᠭ᠄</span><span>{{bookContent[0].publishNum}}</span>
                        <br><span class="fgq f18 mb-2"> ᠬᠡᠪᠯᠡᠯ ᠦᠨ ᠬᠣᠷᠢᠶ᠎ᠠ᠄</span><span>{{bookContent[0].press}}</span>
                    </p>
                </div>
            </div>
            <div class="col-md-2 mgl">
                <div class="action">
                    <a *ngIf="bookContent[0].readUrl" href="{{bookContent[0].readUrl}}" target="_blank" class="fgq btn" style="margin-bottom: 5px;"><i  class="ico-eye"></i>ᠤᠩᠰᠢᠶ᠎ᠠ</a>
                    <a *ngIf="bookContent[0].downloadUrl" href="{{bookContent[0].downloadUrl}}" target="_blank" class="fgq btn"><i  class="ico-download"></i> ᠪᠠᠭᠤᠯᠭᠠᠶ᠎ᠠ </a>
                </div>
                <p class="fqg f18 ml-5 c999">ᠲᠣᠳᠣᠷᠬᠠᠶᠢᠯᠠᠯ᠄ ᠨᠣᠮ ᠤᠩᠰᠢᠬᠤ᠂ ᠪᠠᠭᠤᠯᠭᠠᠬᠤ ᠴᠢᠳᠠᠮᠵᠢ ᠶᠢ <a href="https://doc.onon.cn" class="sites">ᠣᠨᠣᠨ ᠳ᠋ᠣᠺ ᠰᠦᠯᠵᠢᠶ᠎ᠡ <span >( https://doc.onon.cn )</span></a> ᠳᠤ ᠭᠦᠢᠴᠡᠳᠬᠡᠨ᠎ᠡ᠃ </p>
            </div>
        </div>
    </div>
    <div class="container mt-5">
        <div class="row justify-content-center"><span class="col lpat"></span>
            <h4 class="col mgl catName justify-content-center fgq">ᠰᠢᠨ᠎ᠡ ᠨᠡᠮᠡᠭᠰᠡᠨ ᠨᠣᠮ ᠤᠳ</h4><span class="col lpat"></span></div>
        <div class="row">
            <div class="col-6 col-sm-6 col-md-4 col-xl-2dot4 book media position-relative pl-0 mb-5" *ngFor="let nb of newBookList">
                <img alt="" class="shadow mr-3" src="http://api.nomiinoboo.com/{{nb.bookImage}}">
                <div class="media-body mgl">
                    <h5 class="m-0 fgq f18">{{nb.title}}</h5>
                    <a class="stretched-link" href="/book/{{nb.bookId}}"></a>
                </div>
            </div>
        </div>
    </div>
</div>